import React, { useState } from 'react';
import Dropdown from '../../../../components/Dropdown';
import Button from '../../../../components/Button';
import styles from '../css/GenericDictFilters.module.css';

const GenericDictFilters = ({ onSearch, onFilterChange, filters }) => {
  const [searchValue, setSearchValue] = useState('');
  const [localFilters, setLocalFilters] = useState(filters);

  // Sample options - these would typically come from an API
  const activeIngredientOptions = [
    'Ciprofloxacin',
    'Amoxicillin',
    'Azithromycin',
    'Doxycycline',
    'Metronidazole'
  ];

  const manufacturerOptions = [
    'Aurobindo Pharma',
    'Cipla Medpro',
    'Mylan Pharma',
    'Activo Health',
    'Hetero Drugs',
    'Sandoz',
    'Teva'
  ];

  const brandOptions = [
    'Augmentin',
    'Altacef',
    'Duriva',
    'Hetbacin',
    'Hetracin'
  ];

  const handleFilterChange = (filterType, value) => {
    const newFilters = {
      ...localFilters,
      [filterType]: value
    };
    setLocalFilters(newFilters);
    onFilterChange(newFilters);
  };

  const handleSearchChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSearchSubmit = () => {
    onSearch(searchValue);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSearchSubmit();
    }
  };

  return (
    <div className={styles.filtersContainer}>
      <div className={styles.filtersRow}>
        <div className={styles.filterGroup}>
          <Dropdown
            name="activeIngredient"
            options={activeIngredientOptions}
            value={localFilters.activeIngredient}
            onChange={(value) => handleFilterChange('activeIngredient', value)}
            placeholder="Active Ingredient"
            className={styles.dropdown}
          />
        </div>
        
        <div className={styles.filterGroup}>
          <Dropdown
            name="manufacturer"
            options={manufacturerOptions}
            value={localFilters.manufacturer}
            onChange={(value) => handleFilterChange('manufacturer', value)}
            placeholder="Manufacturer"
            className={styles.dropdown}
          />
        </div>
        
        <div className={styles.filterGroup}>
          <Dropdown
            name="brand"
            options={brandOptions}
            value={localFilters.brand}
            onChange={(value) => handleFilterChange('brand', value)}
            placeholder="Brand"
            className={styles.dropdown}
          />
        </div>
        
        <div className={styles.searchGroup}>
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Search..."
            value={searchValue}
            onChange={handleSearchChange}
            onKeyPress={handleKeyPress}
          />
          <Button
            onClick={handleSearchSubmit}
            variant="primary"
            className={styles.searchButton}
          >
            Search
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GenericDictFilters;
